import React, { Component } from 'react';
import './css/tinkerGround.css';
import './css/mainUi.css';


import * as THREE from 'three';
import Stats from 'stats-js';

import { OrbitControls } from './OrbitControls.js';
import { LightProbeGenerator } from 'three/examples/jsm/lights/LightProbeGenerator.js';
import { TweenMax, Sine, Expo, } from "gsap";
import { post } from "./API"

import * as dat from 'dat.gui';

import placeHolderImg from './img/empty.png';

import * as Common from "common/Scene"

class TinkerGrounds extends Component {

	constructor(props) {
		super(props);

		this.divRef = React.createRef();

		this.state = {
			ratioDivisor: this.props.ratioDivisor,
			weakDeviceRatioDivisor: this.props.weakDeviceRatioDivisor,
			textureArray: this.props.textures,
			token: '',
			transmissionMultiplicator: 1.0,
		}
	}

	componentDidMount() {
		this.specifyDemo = null;
		this.extraEnvMap = null;

		this.customTransmission = false;
		this.customTransmitMap = null;

		const queryString = window.location.search;

		let useLocalDefaultId = true;
		let demoId = null;
		let noIdDef = true;
		let showFPSIndicator = null;
		let strToFetch = 'https://dev02.web-ar.media/api/assets/1' /*'https://api.uvex.web-ar.media/api/assets/product/'*/ /*'https://dev01.web-ar.media/api/assets/1'*/;

		this.showFps = false;

		if (queryString) {
			const urlParams = new URLSearchParams(queryString);
			if (urlParams.get('demo')) {
				demoId = urlParams.get('demo');
				noIdDef = false;
			}

			if (urlParams.get('id')) {
				demoId = urlParams.get('id');
				noIdDef = false;
			}

			showFPSIndicator = urlParams.get('fps');

			if (demoId.toString().toLowerCase().indexOf("lidl", 0) !== -1) {
				this.specifyDemo = "lidl";
			}

			if (showFPSIndicator) {
				this.showFps = true;
			}

			useLocalDefaultId = false;
		}

		let url = window.location.href;
		let parts = url.split("/");
		let parent = parts.pop();

		if (parent && parent.indexOf("localhost", 0) === -1) {
			document.title = "Web-AR"/*documentTitle.charAt(0).toUpperCase() + documentTitle.slice(1)*/;
		}

		if (this.subDomain(url)) {

			let domainParts = url.split(".")[0].split("//")[1];
			document.title = domainParts.charAt(0).toUpperCase() + domainParts.slice(1);

		}

		var self = this;
		this.customConfig = null;
		this.tmGui = false;
		if (!useLocalDefaultId) {
			strToFetch =
				// "https://dev02.web-ar.media/api/assets/product/" + demoId;
				//'https://api.uvex.web-ar.media/api/assets/product/'
				//'https://dev01.web-ar.media/api/assets/product/'
				"https://web-ar.media/osar_assets/config/" + demoId + ".json";
		}

		if (noIdDef) {
			console.error("No id defined, redirecting...");
			window.location.href = "https://web-ar.media";
		}

		(async () => {
			fetch(strToFetch)
				.then(res => res.json())
				.then((data) => {
					console.log("fetched data:", data);
					if (data.viewer.lightSetting.enableEnvironmentMap) {


						var loadXtraCubeMap = new THREE.CubeTextureLoader();

						loadXtraCubeMap.load(

							[data.viewer.lightSetting.envMap1,   //px
							data.viewer.lightSetting.envMap4,   //nx
							data.viewer.lightSetting.envMap2,   //py
							data.viewer.lightSetting.envMap5,   //ny
							data.viewer.lightSetting.envMap3,   //pz
							data.viewer.lightSetting.envMap6], //nz
							function (xtraCubeMap) {

								xtraCubeMap.encoding = THREE.sRGBEncoding;
								self.extraEnvMap = xtraCubeMap;

								document.getElementById("logging").style.display = "none";

								self.setup(data);

							}

						);

					} else {
						self.setup(data);
					}

				});

		})();
	}

	setup(json) {
		////////////////////////////////////////////////////////////////////
		// setup:           ////////////////////////////////////////////////
		// default values   ////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		this.shadowRender = true;

		this.multiObjFirst = null;
		this.gltfObject = null;
		this.textureList = {};
		this.customConfig = json;
		this.pinPointNameKey = null;
		this.hasPinPoints = false;
		this.showPins = false;
		this.countPins = 0;

		this.billboards = [];
		this.parkedBillboard = null;

		this.animationClips = null;
		this.mixer = null;
		this.shadowMixer = null;
		this.currentMixer = null;
		this.currentShadowMixer = null;
		this.clock = new THREE.Clock();

		this.multipleModels = false;
		this.actualModel = 0;
		this.multipleLoadCnt = 0;
		this.multipleGlbObj = null;

		this.controls = null;
		this.backScene = null;
		this.modelShadowCaster = null;

		this.lightContainer = null;
		this.ambientLight = null;

		this.emissiveMap = null;

		this.currPos = new THREE.Vector3(0, 0, 0);
		this.currRot = 0;
		this.currScale = 1;

		this.getPastAzimuth = null;



		////////////////////////////////////////////////////////////////////
		// push:                                ////////////////////////////
		// textures from cms to texture-array   ////////////////////////////
		////////////////////////////////////////////////////////////////////

		if (this.customConfig.viewer.backgroundTextureEnabled) {

			this.state.textureArray.push([this.customConfig.viewer.graphicalElement.background, "sceneBackground"]);

		}

		for (let i = 0; i < this.customConfig.objects.length; i++) {
			if (this.customConfig.objects[i].enablePinPoints) {
				for (let j = 0; j < this.customConfig.objects[i].pinPoints.length; j++) {

					this.countPins++;
					this.state.textureArray.push([this.customConfig.objects[i].pinPoints[j].desktop[0], this.customConfig.objects[i].pinPoints[j].name, 0]);

					if (i == 0) {
						this.pinPointNameKey = this.customConfig.objects[i].pinPoints[j].name;
					}
				}
			}
		}

		////////////////////////////////////////////////////////////////////
		// setup:           ////////////////////////////////////////////////
		// default values   ////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		this.composer = null;

		this.isRunning = false;
		this.renderUpdate = true;
		this.generateQrCode = false;
		this.isFullScreen = false;
		this.loadCount = 0;
		this.autoRotationCount = 0;
		this.startRotationAt = this.customConfig.autoRotationStart;
		this.startTime = performance.now();
		this.stats = new Stats();


		////////////////////////////////////////////////////////////////////
		// setup:           ////////////////////////////////////////////////
		// default values   ////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////
		if (this.customConfig.viewer.lightSetting.enableIBL) {

			var loadIblCubeMap = new THREE.CubeTextureLoader();

			loadIblCubeMap.load(
				//urls: string[],
				[this.customConfig.viewer.lightSetting.IBLEnvMap1,   //px
				this.customConfig.viewer.lightSetting.IBLEnvMap4,   //nx
				this.customConfig.viewer.lightSetting.IBLEnvMap2,   //py
				this.customConfig.viewer.lightSetting.IBLEnvMap5,   //ny
				this.customConfig.viewer.lightSetting.IBLEnvMap3,   //pz
				this.customConfig.viewer.lightSetting.IBLEnvMap6], //nz	

				//onLoad ?: (texture: CubeTexture) => void,
				(cubeTextureLightProbe) => {
					cubeTextureLightProbe.encoding = THREE.sRGBEncoding;
					this.textureList[this.state.textureArray[this.loadCount][1]] = cubeTextureLightProbe;
					//this.state.textureArray[0][1] = cubeTextureLightProbe;
					//cubeTextureIrradiance.mapping = THREE.CubeReflectionMapping;
					this.postSetup();
				}
			);
		} else {
			this.postSetup();
		}
	}

	postSetup() {
		this.divRef.current.addEventListener('scroll', (e) => { e.preventDefault(); }, { passive: false });
		this.divRef.current.addEventListener('touchmove', (e) => { if (e.scale !== 1) e.preventDefault(); }, { passive: false });

		document.getElementById("camerafeed").style.display = "none";

		(async () => {
			this.loadModel();
		})();
	}

	loadModel() {
		if (this.customConfig.objects.length > 1) {
			this.multipleModels = true;
			this.multipleGlbObj = [];

			this.multipleModelsLoader(this.actualModel);
		} else {
			this.internalLoadModel(
				0,
				false,
				() => {
					this.loadCount = 1;
					this.loadTextures(this.customConfig.objects[0].baseScene);
				});
		}

	}
	multipleModelsLoader() {
		if (this.multipleLoadCnt < this.customConfig.objects.length) {
			this.internalLoadModel(
				this.multipleLoadCnt,
				true,
				() => {
					this.multipleLoadCnt++;
					if (this.multipleLoadCnt < this.customConfig.objects.length) {
						this.multipleModelsLoader();
					} else {
						this.loadCount = 1;
						this.loadTextures(this.multiObjFirst);
					}
				});
		}

	}
	internalLoadModel(_index, _expectMultiple, _onLoad) {
		this.gltfObject = new THREE.Object3D();
		Common.getGltfLoader().load(this.customConfig.objects[_index].glb,
			(gltf) => {

				if (this.customConfig.objects[_index].enableAnimations) {

					this.customConfig.objects[_index].finalContentScene = gltf.scene;
					this.customConfig.objects[_index].finalAnimationClips = gltf.animations;
					this.customConfig.objects[_index].currentAnimation = 0;
					this.customConfig.objects[_index].finiteState = true;
					this.customConfig.objects[_index].finalClipNames = [];

					for (let i = 0; i < this.customConfig.objects[_index].animations.length; i++) {
						this.customConfig.objects[_index].finalClipNames.push(this.customConfig.objects[_index].animations[i].name);
					}
					if (this.customConfig.objects[_index].finalAnimationClips < this.customConfig.objects[_index].finalClipNames) console.error("Config has more animations that gltf, this might cause issues");
				}

				this.customConfig.objects[_index].baseScene = gltf.scene;


				if (_expectMultiple && this.multipleLoadCnt === 0) {
					this.multiObjFirst = gltf.scene;
				}
				this.gltfObject.add(gltf.scene);
				this.gltfObject.rotation.y = .78;

				this.propagateShadow(gltf.scene);

				gltf.scene.traverse((object) => {
					if (object.material) {
						if (object.material.type.toString() === 'MeshPhysicalMaterial') {
							if (object.material.transmissionMap) {
								object.material.transparent = true;
								this.tmGui = true;
							}
							object.material.needsUpdate = true;
						}
					}

					let getNameKey = object.name.substring(0, object.name.length - 1);

					if (getNameKey && this.pinPointNameKey) {

						if (getNameKey.toLowerCase() === this.pinPointNameKey.substring(0, this.pinPointNameKey.length - 1).toLowerCase()) {

							this.hasPinPoints = true;
							this.showPins = false;
						}
					}
				});

				if (_expectMultiple) {
					this.multipleGlbObj.push([gltf.scene, this.customConfig.objects[this.multipleLoadCnt]]);
				}

				THREE.Cache.clear();

				this.customConfig.objects[_index].finalShadowObject = gltf.scene.clone();
				this.customConfig.objects[_index].finalShadowAnim = gltf.animations.map(x => x.clone());

				_onLoad();


			}, function (xhr) {

				if (xhr.lengthComputable) {
					window.setLoader(Math.round(xhr.loaded / xhr.total * 100));

				}

			});
	}

	loadTextures(gltfScene) {
		let _self = this;
		if (this.loadCount < this.state.textureArray.length) {
			var loadTexture = new THREE.TextureLoader();
			loadTexture.load(this.state.textureArray[this.loadCount][0], function (texture) {
				texture.wrapS = THREE.RepeatWrapping;
				texture.wrapT = THREE.RepeatWrapping;
				texture.minFilter = THREE.LinearMipMapLinearFilter;
				texture.magFilter = THREE.LinearFilter;
				texture.anisotropy = 16;

				if (typeof _self.state.textureArray[_self.loadCount][2] === "undefined") {

					_self.textureList[_self.state.textureArray[_self.loadCount][1]] = texture;

				} else {

					_self.textureList[_self.state.textureArray[_self.loadCount][1].toLowerCase() + "_objLevel_" + _self.state.textureArray[_self.loadCount][2]] = texture;

				}

				_self.loadCount += 1;

				window.setLoader(Math.round(_self.loadCount / (_self.state.textureArray.length + 1) * 100));
				_self.loadTextures(gltfScene);

			});

		} else {

			var myVar = setInterval(myTimer, 30);
			var opacity = 0.9;
			window.proTip();
			this.propagateShadow(gltfScene);

			////////////////////////////////////////////////////////////////////
			// setup:                                            ///////////////
			// check for emissiveMap and if... set it            ///////////////
			////////////////////////////////////////////////////////////////////

			if (this.customConfig.objects[0].enableEmissionMap) {
				if (this.customConfig.objects[0].emissionMap) {
					var loadEmissiveTexture = new THREE.TextureLoader();
					loadEmissiveTexture.load(this.customConfig.objects[0].emissionMap, function (texture) {

						texture.flipY = true;
						texture.anisotropy = 16;
						texture.needsUpdate = true;

						let obj = null;

						_self.gltfObject.children[0].traverse(function (object) {

							if (object.material) {

								if (object.material.emissiveMap) {

									let emissiveBmp = texture.clone();
									emissiveBmp.needsUpdate = true;

									object.material.emissiveMap = emissiveBmp;
									object.material.emissiveMap.encoding = THREE.sRGBEncoding;

									object.material.needsUpdate = true;

									obj = object;

								}

							}

						});
						_self.emissiveMap = obj.material;
						_self.setupUiComponents(_self.customConfig);
					});
				}
			} else {
				this.setupUiComponents(this.customConfig);
			}

			this.initScene();

			if (this.customConfig.objects[0].enablePinPoints) {
				this.setupPinPoints(gltfScene, 0, this.customConfig);
			}

			////////////////////////////////////////////////////////////////////
			// fade-out:                                         ///////////////
			// loading-screen                                    ///////////////
			////////////////////////////////////////////////////////////////////

			document.getElementById("loading").style.opacity = 1;

			function myTimer() {

				if (_self.isRunning >= 2) {
					opacity -= 0.02;

					if (opacity <= 0) {

						clearInterval(myVar);
						document.getElementById("loading").style.display = "none";
						document.getElementById("dot1").style.display = "none";
						document.getElementById("dot2").style.display = "none";

					} else {

						document.getElementById("loading").style.opacity = opacity;


					}

				}
			}
		}
	}


	setupUiComponents(customConfig) {

		var self = this;
		var div = null;
		var showNavi = false;


		////////////////////////////////////////////////////////////////////
		// logo:                   /////////////////////////////////////////
		// user clicked on logo    /////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let logo = null;

		if (this.customConfig.viewer.headerLogoEnabled) {

			logo = document.getElementById('logoHref');
			if (logo) {
				logo.firstElementChild.src = this.customConfig.viewer.graphicalElement.logo;
				logo.firstElementChild.className = "brandLogo noSelect pointer";

				logo.href = this.customConfig.viewer.headerLogoURL;
				logo.target = "_blank";
			} else console.warning("logo not found, not showing headerLogo");

		}

		if (!this.customConfig.viewer.headerLogoURL) {

			logo = document.getElementById('logoHref');
			if (logo) {
				let logoParentElement = logo.parentElement;
				logoParentElement.innerHTML = "<span id='logoHref' ><img id='brandLogo' src='" + this.customConfig.viewer.graphicalElement.logo + "' class='brandLogo noSelect' /></span>";
			} else console.warning("logo not found, not showing headerLogoURL");

		}

		if (!this.customConfig.viewer.headerLogoEnabled) {

			logo = document.getElementById('logoHref');
			if (logo) {
				let logoParentElement = logo.parentElement;
				logoParentElement.innerHTML = "<span id='logoHref' ></span>";
			} else console.warning("logo not found, not showing headerLogo");


		}



		////////////////////////////////////////////////////////////////////
		// ar-toggle button:             ///////////////////////////////////
		// user clicked on ar-toggle     ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let getQRcodeLayover = document.getElementById('qrcode-layover');
		if (getQRcodeLayover) getQRcodeLayover.style.display = "none";
		let showInCorner = false;
		if (this.customConfig.viewer.activeAR) {
			let ArImage;
			if (showInCorner) {
				ArImage = document.getElementById("arImage");
				ArImage.src = this.customConfig.viewer.graphicalElement.ar3DButtonPassive;
				ArImage.style.width = "100%";
			} else {
				ArImage = document.getElementById("arImage");
				ArImage.src = this.customConfig.viewer.graphicalElement.ar3DButtonPassive;
				ArImage.className = "menuIcon";

				div = document.getElementById("menuIcons");
				div.appendChild(document.getElementById("arAnchor"));
				div.appendChild(document.createElement("br"));
			}

			let getQRcodeClearText = document.getElementById('qrcode-cleartext');
			getQRcodeClearText.innerHTML = this.customConfig.qrcodeUrl;


			getQRcodeLayover = document.getElementById('qrcode-layover');
			getQRcodeLayover.style.display = "none";
			let getQRcodeInnerWindow = document.getElementById('qrcode-window');
			getQRcodeInnerWindow.style.opacity = 0;

			if (window.isMobile) {
				if (navigator.userAgent.indexOf("Safari") > -1) {
					if (navigator.userAgent.indexOf('Chrome') > -1) {
						document.getElementById("arAnchor").setAttribute("href", "intent://arvr.google.com/scene-viewer/1.0?file=" +
							this.customConfig.objects[0].glb +
							"&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;");
					} else {
						document.getElementById("arAnchor").setAttribute("href", this.customConfig.objects[0].usdz);
					}
				}
			} else {

				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				// show: QR-Code layer               /////////////////////////////////////////////////////////////////////////////////////
				//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

				const showQRcodeLayover = () => {

					if (!this.generateQrCode) {
						let url = window.location.href;
						//TODO: replace 3d=doAR with doAR=true and doAR=false
						if (url.toString().indexOf("&3d=doAR", 0) !== -1) {
							url = url.replace("&3d=doAR", "");
						} else if (url.toString().indexOf("?3d=doAR&", 0) !== -1) {
							url = url.replace("?3d=doAR&", "?");
						} else if (url.toString().indexOf("?3d=doAR", 0) !== -1) {
							url = url.replace("?3d=doAR&", "");
						}
						console.log(url);
						window.generateQR(url);
						this.generateQrCode = true;

					}

					var getQRcodeLayover = document.getElementById('qrcode-layover');
					getQRcodeLayover.style.width = "100%";
					getQRcodeLayover.style.height = "100%";
					getQRcodeLayover.style.display = "flex";

					var getQRcodeInnerWindow = document.getElementById('qrcode-window');
					getQRcodeInnerWindow.style.display = "block";

					TweenMax.to(getQRcodeInnerWindow, 0.8, { css: { opacity: 1 }, ease: Sine.easeOut });

				}

				ArImage.addEventListener('click', showQRcodeLayover);


				const closeQrButtonClick = () => {

					TweenMax.to(getQRcodeInnerWindow, 0.5, {
						css: { opacity: 0 }, ease: Expo.easeOut, onComplete: function () {

							getQRcodeLayover.style.width = "1%";
							getQRcodeLayover.style.height = "1%";
							getQRcodeLayover.style.display = "none";
							getQRcodeInnerWindow.style.display = "none";

						}
					});

				}

				document.getElementById('qrcode-close-english').addEventListener('click', closeQrButtonClick);
				document.getElementById('qrcode-close-german').addEventListener('click', closeQrButtonClick);

			}

		} else {
			document.getElementById("arToggle").style.display = "none";
		}



		////////////////////////////////////////////////////////////////////
		// fullscreen button                     ///////////////////////////
		// user clicked on fullscreen-button     ///////////////////////////
		////////////////////////////////////////////////////////////////////

		if (this.customConfig.viewer.fullScreenButtonEnabled) {

			showNavi = true;

			var maximizeImg = document.createElement("img");
			maximizeImg.src = this.customConfig.viewer.graphicalElement.fullScreenButtonNormal;
			maximizeImg.className = "menuIcon";
			var maximizeLinebreak = document.createElement("br");

			div = document.getElementById("menuIcons");
			div.appendChild(maximizeImg);
			div.appendChild(maximizeLinebreak);


			maximizeImg.addEventListener('click', () => {

				if (self.isFullScreen) {

					if (document.exitFullscreen) document.exitFullscreen();
					else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
					else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
					else if (document.msExitFullscreen) document.msExitFullscreen();

				}
				else {

					const elem = document.documentElement;
					if (elem.requestFullscreen) elem.requestFullscreen();
					else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
					else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
					else if (elem.msRequestFullscreen) elem.msRequestFullscreen();

				}

				self.isFullScreen = !self.isFullScreen;

			});

		}



		////////////////////////////////////////////////////////////////////
		// recenter button               ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		if (this.customConfig.viewer.recenterButtonEnabled) {

			showNavi = true;

			var recenterImg = document.createElement("img");
			recenterImg.src = this.customConfig.viewer.graphicalElement.reCenterButtonNormal;
			recenterImg.className = "menuIcon";
			recenterImg.id = "recenterImg";
			var recenterLinebreak = document.createElement("br");

			div = document.getElementById("menuIcons");
			div.appendChild(recenterImg);
			div.appendChild(recenterLinebreak);

			const recenterScenery = () => {

				self.resetAutoRotation(self);
				this.controls.reset();
				this.resize();

			}

			recenterImg.addEventListener('click', recenterScenery);

		}



		////////////////////////////////////////////////////////////////////
		// show animation(s) button      ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let animationsImg = document.createElement("img");
		let animationsLinebreak = document.createElement("br");

		if (this.customConfig.objects[0].enableAnimations) {

			showNavi = true;

			animationsImg.id = "uniqueAnimationsImg";
			animationsImg.src = this.customConfig.viewer.graphicalElement.animateButtonNormal;
			animationsImg.className = "menuIcon";
			animationsLinebreak.id = "uniqueAnimationsLinkBr";

			div = document.getElementById("menuIcons");
			div.appendChild(animationsImg);
			div.appendChild(animationsLinebreak);

		} else {

			animationsImg.id = "uniqueAnimationsImg";
			animationsImg.src = this.customConfig.viewer.graphicalElement.animateButtonNormal;
			animationsImg.className = "menuIcon";

			animationsLinebreak.id = "uniqueAnimationsLinkBr";

			div = document.getElementById("menuIcons");
			div.appendChild(animationsImg);
			div.appendChild(animationsLinebreak);

			animationsImg.style.display = "none";
			animationsLinebreak.style.display = "none";

		}

		const playAnimation = (_mouseEvent) => {

			if (!self.customConfig.objects[self.actualModel].finiteState) return;

			if (self.mixer) {
				self.mixer.stopAllAction();
				self.mixer.uncacheRoot(self.mixer.getRoot());
				self.mixer = null;
			}

			if (self.shadowMixer) {
				self.shadowMixer.stopAllAction();
				self.shadowMixer.uncacheRoot(self.shadowMixer.getRoot());
				self.shadowMixer = null;
			}

			self.mixer = new THREE.AnimationMixer(self.customConfig.objects[self.actualModel].finalContentScene);
			self.shadowMixer = new THREE.AnimationMixer(self.customConfig.objects[self.actualModel].finalShadowObject);

			let clipNames = self.customConfig.objects[self.actualModel].finalClipNames;


			let clip = THREE.AnimationClip.findByName(self.customConfig.objects[self.actualModel].finalAnimationClips, clipNames[self.customConfig.objects[self.actualModel].currentAnimation]);
			let shadowClip = THREE.AnimationClip.findByName(self.customConfig.objects[self.actualModel].finalShadowAnim, clipNames[self.customConfig.objects[self.actualModel].currentAnimation]);
			if (clip) {
				self.currentMixer = self.mixer;
				self.currentShadowMixer = self.shadowMixer;

				self.customConfig.objects[self.actualModel].finiteState = false;

				let action = self.mixer.clipAction(clip);
				let shadowAction = self.shadowMixer.clipAction(shadowClip);

				action.clampWhenFinished = true;
				action.setLoop(THREE.LoopOnce, 1);
				action.play();

				shadowAction.clampWhenFinished = true;
				shadowAction.setLoop(THREE.LoopOnce, 1);
				shadowAction.play();

				self.currentMixer.addEventListener('finished', function (e) {
					self.currentMixer = null;
				});

				self.currentShadowMixer.addEventListener('finished', function (e) {
					self.currentShadowMixer = null;
					self.renderUpdate = false;

					self.customConfig.objects[self.actualModel].currentAnimation++;

					if (self.customConfig.objects[self.actualModel].currentAnimation >= clipNames.length) {
						self.customConfig.objects[self.actualModel].currentAnimation = 0;
					}

					self.customConfig.objects[self.actualModel].finiteState = true;


				});
			}

		}

		animationsImg.addEventListener('click', playAnimation);





		////////////////////////////////////////////////////////////////////
		// show emissive-map button      ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let emissiveImg = document.createElement("img");
		let emissiveLinebreak = document.createElement("br");

		if (this.emissiveMap) {

			if (this.customConfig.objects[0].enableEmissionMap) {

				showNavi = true;

				emissiveImg.id = "uniqueEmissiveImg";
				emissiveImg.src = this.customConfig.viewer.graphicalElement.emissiveButtonNormal;
				emissiveImg.className = "menuIcon";
				emissiveLinebreak.id = "uniqueEmissiveLinkBr";

				div = document.getElementById("menuIcons");
				div.appendChild(emissiveImg);
				div.appendChild(emissiveLinebreak);

			} else {

				emissiveImg.id = "uniqueEmissiveImg";
				emissiveImg.src = this.customConfig.viewer.graphicalElement.emissiveButtonNormal;
				emissiveImg.className = "menuIcon";

				emissiveLinebreak.id = "uniqueEmissiveLinkBr";

				div = document.getElementById("menuIcons");
				div.appendChild(emissiveImg);
				div.appendChild(emissiveLinebreak);

				emissiveImg.style.display = "none";
				emissiveLinebreak.style.display = "none";

				this.gltfObject.children[0].traverse(function (object) {

					if (object.material) {

						if (object.material.emissiveMap) {

							object.material.emissiveMap = null;
							object.material.emissive = 0x000000;
							object.material.needsUpdate = true;

						}

					}

				});

			}

		} else {

			emissiveImg.id = "uniqueEmissiveImg";
			emissiveImg.src = this.customConfig.viewer.graphicalElement.emissiveButtonNormal;
			emissiveImg.className = "menuIcon";

			emissiveLinebreak.id = "uniqueEmissiveLinkBr";

			div = document.getElementById("menuIcons");
			div.appendChild(emissiveImg);
			div.appendChild(emissiveLinebreak);

			emissiveImg.style.display = "none";
			emissiveLinebreak.style.display = "none";

		}

		const handleEmissiveIntensity = () => {

			console.log(self.emissiveMap)
			if (self.emissiveMap.emissiveIntensity === 1) {

				self.emissiveMap.emissiveIntensity = 0;


			} else {

				self.emissiveMap.emissiveIntensity = 1;

			}

			self.emissiveMap.needsUpdate = true;
			self.renderUpdate = true;

		}

		emissiveImg.addEventListener('click', handleEmissiveIntensity);



		////////////////////////////////////////////////////////////////////
		// show pin-point(s) button      ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let pinPntImg = document.createElement("img");
		let pinPntbreak = document.createElement("br");

		if (this.customConfig.objects[0].enablePinPoints) {

			showNavi = true;

			if (this.hasPinPoints) {

				pinPntImg.id = "uniquePinPointImg";
				pinPntImg.src = this.customConfig.viewer.graphicalElement.pinPointButtonNormal;
				pinPntImg.className = "menuIcon";
				pinPntbreak.id = "uniquePinPointLinkBr";

				div = document.getElementById("menuIcons");
				div.appendChild(pinPntImg);
				div.appendChild(pinPntbreak);

			}


			const showPinpoints = () => {

				var _self = this;

				this.gltfObject.traverse(function (object) {

					let getNameKey = object.name.substring(0, object.name.length - 1);
					let getNameKeyAdvanced = self.pinPointNameKey.substring(0, self.pinPointNameKey.length - 2).toLowerCase() + "1";

					if (getNameKey.toLowerCase() === self.pinPointNameKey.substring(0, self.pinPointNameKey.length - 1).toLowerCase() || getNameKey.toLowerCase() === getNameKeyAdvanced) {

						if (object.children.length > 0) {

							let mesh = null;
							let line = null;

							if (object.children[0].name.toString().toLowerCase().indexOf("_end", 0) !== -1) {

								mesh = object.children[1];
								line = object.children[2];

							} else {

								mesh = object.children[0];
								line = object.children[1];

							}

							if (_self.showPins) {


								if (typeof mesh !== "undefined" && typeof line !== "undefined" && mesh.material !== "undefined" && line.material !== "undefined") {

									if (mesh) TweenMax.to(mesh.material, 0.5, { opacity: 0.0, onUpdate: function () { _self.renderUpdate = true; }, ease: Sine.easeOut, onComplete: function () { mesh.visible = false; } });
									if (line) TweenMax.to(line.material, 0.5, { opacity: 0.0, onUpdate: function () { _self.renderUpdate = true; }, ease: Sine.easeOut, onComplete: function () { line.visible = false; } });
								}

							} else {

								if (typeof mesh !== "undefined" && typeof line !== "undefined" && mesh.material !== "undefined" && line.material !== "undefined") {

									if (mesh) mesh.visible = true;
									if (line) line.visible = true;

									if (mesh) TweenMax.to(mesh.material, 0.5, { opacity: 1.0, onUpdate: function () { _self.renderUpdate = true; }, ease: Sine.easeOut });
									if (line) TweenMax.to(line.material, 0.5, { opacity: 1.0, onUpdate: function () { _self.renderUpdate = true; }, ease: Sine.easeOut });

								}

							}

						}

					}

				});

				if (this.showPins) {

					this.showPins = false;

				} else {

					this.showPins = true;

				}

			}

			pinPntImg.addEventListener('click', showPinpoints);

		} else {

			pinPntImg.id = "uniquePinPointImg";
			pinPntImg.src = this.customConfig.viewer.graphicalElement.pinPointButtonNormal;
			pinPntImg.className = "menuIcon";

			pinPntbreak.id = "uniquePinPointLinkBr";

			div = document.getElementById("menuIcons");
			div.appendChild(pinPntImg);
			div.appendChild(pinPntbreak);

			pinPntImg.style.display = "none";
			pinPntbreak.style.display = "none";
		}



		////////////////////////////////////////////////////////////////////
		// video button                  ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let videoLink = null;
		let videoLinebreak = null;
		let videoImg = null;

		if (this.customConfig.objects[0].enableVideoLink) {

			if (this.customConfig.objects[0].videoLink) {

				if (this.customConfig.objects[0].videoLink.length > 5) {

					showNavi = true;

					videoLink = document.createElement("a");
					videoLink.href = this.customConfig.objects[0].videoLink;
					videoLink.target = "_blank";
					videoLink.id = "uniqueVideoLink";
					videoLinebreak = document.createElement("br");
					videoLinebreak.id = "uniqueVideoLinkBr";

					videoImg = document.createElement("img");
					videoImg.src = this.customConfig.viewer.graphicalElement.videoButtonNormal;
					videoImg.className = "menuIcon";

					videoLink.appendChild(videoImg);

					div = document.getElementById("menuIcons");
					div.appendChild(videoLink);
					div.appendChild(videoLinebreak);

				}

			}

		} else {

			videoLink = document.createElement("a");
			videoLink.href = "#";
			videoLink.target = "_blank";
			videoLink.id = "uniqueVideoLink";
			videoLinebreak = document.createElement("br");
			videoLinebreak.id = "uniqueVideoLinkBr";

			videoImg = document.createElement("img");

			if (this.customConfig.viewer.graphicalElement.videoButtonNormal) {

				videoImg.src = this.customConfig.viewer.graphicalElement.videoButtonNormal;

			} else {

				videoImg.src = placeHolderImg;

			}

			videoImg.className = "menuIcon";

			videoLink.appendChild(videoImg);

			div = document.getElementById("menuIcons");
			div.appendChild(videoLink);
			div.appendChild(videoLinebreak);

			videoLink.style.display = "none";
			videoLinebreak.style.display = "none";

		}


		////////////////////////////////////////////////////////////////////
		// shop button                   ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let shopLink = null;
		let shopLinebreak = null;
		let shopImg = null;

		if (this.customConfig.objects[0].enableShopLink) {

			if (this.customConfig.objects[0].shopLink) {

				if (this.customConfig.objects[0].shopLink.length > 5) {

					showNavi = true;

					shopLink = document.createElement("a");
					shopLink.href = this.customConfig.objects[0].shopLink;
					shopLink.target = "_blank";
					shopLink.id = "uniqueShopLink";
					shopLinebreak = document.createElement("br");
					shopLinebreak.id = "uniqueShopLinkBr";

					shopImg = document.createElement("img");
					shopImg.src = this.customConfig.viewer.graphicalElement.shoppingButtonNormal;
					shopImg.className = "menuIcon";

					shopLink.appendChild(shopImg);

					div = document.getElementById("menuIcons");
					div.appendChild(shopLink);
					div.appendChild(shopLinebreak);

				}

			}

		} else {

			shopLink = document.createElement("a");
			shopLink.href = "#";
			shopLink.target = "_blank";
			shopLink.id = "uniqueShopLink";
			shopLinebreak = document.createElement("br");
			shopLinebreak.id = "uniqueShopLinkBr";

			shopImg = document.createElement("img");

			if (this.customConfig.viewer.graphicalElement.videoButtonNormal) {

				shopImg.src = this.customConfig.viewer.graphicalElement.shoppingButtonNormal;

			} else {

				shopImg.src = placeHolderImg;

			}

			shopImg.className = "menuIcon";

			shopLink.appendChild(shopImg);

			div = document.getElementById("menuIcons");
			div.appendChild(shopLink);
			div.appendChild(shopLinebreak);

			shopLink.style.display = "none";
			shopLinebreak.style.display = "none";

		}


		////////////////////////////////////////////////////////////////////
		// model-toggle button           ///////////////////////////////////
		////////////////////////////////////////////////////////////////////

		if (this.customConfig.objects.length > 1) {

			showNavi = true;

			var toggleImg = document.createElement("img");
			toggleImg.src = this.customConfig.viewer.graphicalElement.modelToggleButtonNormal;
			toggleImg.className = "menuIcon";
			toggleImg.id = "toggleImg";
			var toggleLinebreak = document.createElement("br");

			div = document.getElementById("menuIcons");
			div.appendChild(toggleImg);
			div.appendChild(toggleLinebreak);

			const toggleModels = () => {


				self.actualModel += 1;


				////////////////////////////////////////////////////////////////////
				// remove: current model    ////////////////////////////////////////
				////////////////////////////////////////////////////////////////////

				if (self.actualModel === self.customConfig.objects.length) self.actualModel = 0;

				if (self.parkedBillboard && self.actualModel === 0) {

					self.parkedBillboard.material.opacity = 0;

				}

				if (self.parkedBillboard && self.actualModel === 1) {

					self.parkedBillboard.material.opacity = 1;

				}


				self.gltfObject.remove(self.gltfObject.children[0]);



				////////////////////////////////////////////////////////////////////
				// add actual model (gltf/glb)    //////////////////////////////////
				////////////////////////////////////////////////////////////////////

				self.gltfObject.add(self.multipleGlbObj[self.actualModel][0]);



				////////////////////////////////////////////////////////////////////
				// cast shadows for every model(s) object    ///////////////////////
				////////////////////////////////////////////////////////////////////

				self.propagateShadow(self.multipleGlbObj[self.actualModel][0]);



				////////////////////////////////////////////////////////////////////
				// check: if toggled model has animations    ///////////////////////
				////////////////////////////////////////////////////////////////////

				if (self.multipleGlbObj[self.actualModel][1].enableAnimations) {

					document.getElementById("uniqueAnimationsImg").removeAttribute("style");
					document.getElementById("uniqueAnimationsLinkBr").removeAttribute("style");

				} else {

					document.getElementById("uniqueAnimationsImg").style.display = "none";
					document.getElementById("uniqueAnimationsLinkBr").style.display = "none";

				}

				////////////////////////////////////////////////////////////////////
				// check: if toggled model has pin-points    ///////////////////////
				////////////////////////////////////////////////////////////////////

				self.hasPinPoints = false;

				if (self.multipleGlbObj[self.actualModel][1].enablePinPoints) {

					document.getElementById("uniquePinPointImg").removeAttribute("style");
					document.getElementById("uniquePinPointLinkBr").removeAttribute("style");

					self.hasPinPoints = true;
					self.setupPinPoints(self.multipleGlbObj[self.actualModel][0], self.actualModel, self.customConfig);

				} else {

					document.getElementById("uniquePinPointImg").style.display = "none";
					document.getElementById("uniquePinPointLinkBr").style.display = "none";

				}



				////////////////////////////////////////////////////////////////////
				// check: if toggled model uses an emissive-map    /////////////////
				////////////////////////////////////////////////////////////////////

				if (self.multipleGlbObj[self.actualModel][1].enableEmissionMap) {

					document.getElementById("uniqueEmissiveImg").removeAttribute("style");
					document.getElementById("uniqueEmissiveLinkBr").removeAttribute("style");


					var loadEmissiveTexture = new THREE.TextureLoader();
					loadEmissiveTexture.load(self.multipleGlbObj[self.actualModel][1].emissionMap, function (texture) {

						texture.flipY = true;
						texture.anisotropy = 16;
						texture.needsUpdate = true;

						let obj = null;

						self.gltfObject.children[0].traverse(function (object) {

							if (object.material) {

								if (object.material.emissiveMap) {

									let emissiveBmp = texture.clone();
									emissiveBmp.needsUpdate = true;

									object.material.emissiveMap = emissiveBmp;
									object.material.emissiveMap.encoding = THREE.sRGBEncoding;

									object.material.needsUpdate = true;

									obj = object;

								}

							}

						});


						////////////////////////////////////////////////////////////////////
						// setup:                                            ///////////////
						// html ui-component(s) (buttons, logos, ect. )      ///////////////
						////////////////////////////////////////////////////////////////////

						self.emissiveMap = obj.material;


					});

				} else {

					document.getElementById("uniqueEmissiveImg").style.display = "none";
					document.getElementById("uniqueEmissiveLinkBr").style.display = "none";

					self.emissiveMap = null;

					self.gltfObject.children[0].traverse(function (object) {

						if (object.material) {

							if (object.material.emissiveMap) {

								//object.material.emissiveMap = null;
								//object.material.emissive    = 0x000000;
								//object.material.needsUpdate = true; 

							}

						}

					});

				}


				////////////////////////////////////////////////////////////////////
				// overwrite shoplink-button     ///////////////////////////////////
				////////////////////////////////////////////////////////////////////

				if (!self.multipleGlbObj[self.actualModel][1].enableShopLink) {

					document.getElementById("uniqueShopLink").style.display = "none";
					document.getElementById("uniqueShopLinkBr").style.display = "none";

				} else {

					document.getElementById("uniqueShopLink").removeAttribute("style");
					document.getElementById("uniqueShopLinkBr").removeAttribute("style");

					document.getElementById("uniqueShopLink").href = self.multipleGlbObj[self.actualModel][1].shopLink;

				}



				////////////////////////////////////////////////////////////////////
				// overwrite videolink-button     //////////////////////////////////
				////////////////////////////////////////////////////////////////////

				if (!self.multipleGlbObj[self.actualModel][1].enableVideoLink) {

					document.getElementById("uniqueVideoLink").style.display = "none";
					document.getElementById("uniqueVideoLinkBr").style.display = "none";

				} else {

					document.getElementById("uniqueVideoLink").removeAttribute("style");
					document.getElementById("uniqueVideoLinkBr").removeAttribute("style");

					document.getElementById("uniqueVideoLink").href = self.multipleGlbObj[self.actualModel][1].videoLink;

				}

				self.gltfObject.scale.set(1, 1, 1);

				if (self.multipleGlbObj[self.actualModel][1].transformers[0]) {

					if (self.multipleGlbObj[self.actualModel][1].transformers[0].scale)
						self.gltfObject.scale.set(self.multipleGlbObj[self.actualModel][1].transformers[0].scale, self.multipleGlbObj[self.actualModel][1].transformers[0].scale, self.multipleGlbObj[self.actualModel][1].transformers[0].scale);

				}

				self.backScene.remove(self.modelShadowCaster)
				self.modelShadowCaster = null;

				self.modelShadowCaster = new THREE.Object3D();
				self.modelShadowCaster.add(self.multipleGlbObj[self.actualModel][1].finalShadowObject);

				self.modelShadowCaster.position.x = self.gltfObject.position.x;
				self.modelShadowCaster.position.y = self.gltfObject.position.y;
				self.modelShadowCaster.position.z = self.gltfObject.position.z;

				self.modelShadowCaster.rotation.x = self.gltfObject.rotation.x;
				self.modelShadowCaster.rotation.y = self.gltfObject.rotation.y;
				self.modelShadowCaster.rotation.z = self.gltfObject.rotation.z;

				self.modelShadowCaster.scale.set(self.gltfObject.scale.x, self.gltfObject.scale.y, self.gltfObject.scale.z);

				self.modelShadowCaster.traverse(function (object) {

					if (object.name.toString().toLowerCase().indexOf("pinpoint", 0) !== -1) object.visible = false;

					if (object.isMesh) {

						object.castShadow = true;

						object.material = object.material.clone();
						object.material.opacity = 0;
						object.material.transparent = true;
						object.material.side = THREE.FrontSide;
						object.material.depthTest = false;
						object.material.depthWrite = false;
						object.material.colorWrite = false;
						object.material.flatShading = true;

						if (object.material.map) object.material.map = null;
						if (object.material.normalMap) object.material.normalMap = null;
						if (object.material.roughnessMap) object.material.roughnessMap = null;
						if (object.material.metalnessMap) object.material.metalnessMap = null;
						if (object.material.emissiveMap) object.material.emissiveMap = null;
						if (object.material.aoMap) object.material.aoMap = null;
						if (object.material.envMap) object.material.envMap = null;

						object.material.needsUpdate = true;

					}

				});


				self.backScene.add(self.modelShadowCaster);

				if (window.location.href.includes('340059') && self.actualModel === 1 && !self.parkedBillboard) {

					var spriteMaterial = new THREE.SpriteMaterial({ map: new THREE.TextureLoader().load(self.multipleGlbObj[1][1].billboards[0].desktop[0]), transparent: true, opacity: 1.0 });
					var sprite1 = new THREE.Sprite(spriteMaterial);

					sprite1.name = self.multipleGlbObj[1][1].billboards[0].name;

					sprite1.scale.x = self.multipleGlbObj[1][1].billboards[0].scale;
					sprite1.scale.y = self.multipleGlbObj[1][1].billboards[0].scale;

					sprite1.position.x = self.multipleGlbObj[1][1].billboards[0].positionX;
					sprite1.position.y = self.multipleGlbObj[1][1].billboards[0].positionY;
					sprite1.position.z = self.multipleGlbObj[1][1].billboards[0].positionZ;

					self.scene.add(sprite1);

					self.parkedBillboard = sprite1;


				}

				self.renderUpdate = true;

			}

			toggleImg.addEventListener('click', toggleModels);

		}


		/* ---------------------------------------------------------------------------------------------------------------------- */
		/* -- force dom-update: force dom to render ui-elements ----------------------------------------------------------------- */
		/* ---------------------------------------------------------------------------------------------------------------------- */

		var originalBodyStyle = getComputedStyle(document.body).getPropertyValue('display');
		document.body.style.display = 'none';

		setTimeout(() => {

			document.body.style.display = originalBodyStyle;
			this.isRunning++;
		}, 10);

		if (!showNavi) document.getElementById("menu").style.display = "none";

	}

	initScene() {
		////////////////////////////////////////////////////////////////////
		// get:                    /////////////////////////////////////////
		// dom element´s container /////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		let _self = this;
		this.container = this.divRef.current;

		////////////////////////////////////////////////////////////////////
		// setup:                    ///////////////////////////////////////
		// threejs clock & timers    ///////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		this.time = 0;
		this.lastFrame = Date.now();
		this.thisFrame = null;
		this.material = null;

		Common.InitRenderer.call(this, this.customConfig, window.isMobile)

		Common.InitScene.call(this, this.customConfig);

		////////////////////////////////////////////////////////////////////
		// setup:           ////////////////////////////////////////////////
		// orbit-controls   ////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		this.controls = new OrbitControls(this.camera, this.renderer.domElement, {

			base: _self,
			autoRotate: this.customConfig.enableAutorotate,
			playAutoRotation: false,
			resetAutoRotation: this.resetAutoRotation,
			gestureSettings: this.customConfig.viewer.gestureSetting,
			isMobile: window.isMobile

		});
		this.controls.update();

		this.controls.addEventListener('change', () => {

			this.renderUpdate = true;

		});

		////////////////////////////////////////////////////////////////////
		// setup:           ////////////////////////////////////////////////
		// geometry         ////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		const box = new THREE.Box3().setFromObject(this.gltfObject.children[0]);
		const size = box.getSize(new THREE.Vector3()).length();
		const size2 = box.getSize(new THREE.Vector3());
		const center = box.getCenter(new THREE.Vector3());

		this.controls.reset();

		if (this.customConfig.viewer.enableFitToScreen) {

			this.controls.minDistance = this.customConfig.viewer.gestureSetting.zoomMin;
			this.controls.maxDistance = this.customConfig.viewer.gestureSetting.zoomMax;

			this.camera.near = size / 100;
			this.camera.far = size * 100;
			this.camera.updateProjectionMatrix();

			this.camera.position.copy(center);
			this.camera.position.x += size / 2.0;
			this.camera.position.y += size / 5.0;
			this.camera.position.z += size / 2.0;

			if (this.customConfig.objects[0].transformers[0]) {
				this.gltfObject.scale.set(this.customConfig.objects[0].transformers[0].scale, this.customConfig.objects[0].transformers[0].scale, this.customConfig.objects[0].transformers[0].scale);

				this.gltfObject.position.x += this.customConfig.objects[0].transformers[0].positionX;
				this.gltfObject.position.y += this.customConfig.objects[0].transformers[0].positionY;
				this.gltfObject.position.z += this.customConfig.objects[0].transformers[0].positionZ;

				this.gltfObject.rotation.x += this.customConfig.objects[0].transformers[0].rotationX;
				this.gltfObject.rotation.y += this.customConfig.objects[0].transformers[0].rotationY;
				this.gltfObject.rotation.z += this.customConfig.objects[0].transformers[0].rotationZ;
			}

			this.camera.position.x += this.customConfig.viewer.cameraSetting.positionX;
			this.camera.position.y += this.customConfig.viewer.cameraSetting.positionY;
			this.camera.position.z += this.customConfig.viewer.cameraSetting.positionZ;

			this.camera.lookAt(center);

		} else {

			this.gltfObject.position.x += (this.gltfObject.position.x - center.x);
			this.gltfObject.position.y += (this.gltfObject.position.y - center.y);
			this.gltfObject.position.z += (this.gltfObject.position.z - center.z);

			if (this.customConfig.objects[0].transformers[0]) {
				this.gltfObject.scale.set(this.customConfig.objects[0].transformers[0].scale, this.customConfig.objects[0].transformers[0].scale, this.customConfig.objects[0].transformers[0].scale);

				this.gltfObject.rotation.x += this.customConfig.objects[0].transformers[0].rotationX;
				this.gltfObject.rotation.y += this.customConfig.objects[0].transformers[0].rotationY;
				this.gltfObject.rotation.z += this.customConfig.objects[0].transformers[0].rotationZ;

				this.gltfObject.children[0].position.x += this.customConfig.objects[0].transformers[0].positionX;
				this.gltfObject.children[0].position.y += this.customConfig.objects[0].transformers[0].positionY;
				this.gltfObject.children[0].position.z += this.customConfig.objects[0].transformers[0].positionZ;
			}

			this.camera.position.x = this.customConfig.viewer.cameraSetting.positionX;
			this.camera.position.y = this.customConfig.viewer.cameraSetting.positionY;
			this.camera.position.z = this.customConfig.viewer.cameraSetting.positionZ;
		}

		this.controls.saveState();
		this.scene.add(this.gltfObject);

		this.controls.update();

		let cubePositionY = 1;
		if (size2.y > 2) cubePositionY = size2.y * 0.1;


		this.modelShadowCaster = new THREE.Object3D();
		this.modelShadowCaster.add(this.customConfig.objects[0].finalShadowObject);

		this.modelShadowCaster.position.x = this.gltfObject.position.x;
		this.modelShadowCaster.position.y = this.gltfObject.position.y;
		this.modelShadowCaster.position.z = this.gltfObject.position.z;

		this.modelShadowCaster.rotation.x = this.gltfObject.rotation.x;
		this.modelShadowCaster.rotation.y = this.gltfObject.rotation.y;
		this.modelShadowCaster.rotation.z = this.gltfObject.rotation.z;

		this.modelShadowCaster.scale.set(this.gltfObject.scale.x, this.gltfObject.scale.y, this.gltfObject.scale.z);

		this.modelShadowCaster.traverse(function (object) {

			if (object.name.toString().toLowerCase().indexOf("pinpoint", 0) !== -1) object.visible = false;

			if (object.isMesh) {

				object.castShadow = true;

				object.material = object.material.clone();
				object.material.opacity = 1;
				object.material.transparent = true;
				object.material.side = THREE.FrontSide;
				object.material.depthTest = false;
				object.material.depthWrite = false;
				object.material.colorWrite = false;
				object.material.flatShading = true;

				if (object.material.map) object.material.map = null;
				if (object.material.normalMap) object.material.normalMap = null;
				if (object.material.roughnessMap) object.material.roughnessMap = null;
				if (object.material.metalnessMap) object.material.metalnessMap = null;
				if (object.material.emissiveMap) object.material.emissiveMap = null;
				if (object.material.aoMap) object.material.aoMap = null;
				if (object.material.envMap) object.material.envMap = null;

				object.material.needsUpdate = true;

			}

		});

		this.backScene.add(this.modelShadowCaster)

		this.modelShadowCaster.position.y = this.gltfObject.position.y + 0.5;

		//    this.modelShadowCaster.children[0].opacity = 0;
		//    this.modelShadowCaster.children[0].transparent = true;

		this.controls.saveState();

		////////////////////////////////////////////////////////////////////
		// setup:           ////////////////////////////////////////////////
		// light(s)         ////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		//this.lightContainer = null;

		if (this.customConfig.viewer.lightSetting.enableAmbientLight) {

			this.ambientLight = new THREE.AmbientLight(this.customConfig.viewer.lightSetting.ambientLightColor, this.customConfig.viewer.lightSetting.ambientLightIntensity);
			this.scene.add(this.ambientLight);

		}

		var planeGeometry = new THREE.PlaneBufferGeometry(100, 100, 10, 10);
		planeGeometry.rotateX(- Math.PI / 2);
		var planeMaterial = new THREE.ShadowMaterial();
		planeMaterial.opacity = 0.05;

		if (this.customConfig.viewer.lightSetting.dropShadowOpacity !== 0) {
			planeMaterial.opacity = this.customConfig.viewer.lightSetting.dropShadowOpacity;
		}

		var plane = new THREE.Mesh(planeGeometry, planeMaterial);
		plane.receiveShadow = true;

		plane.position.y = this.gltfObject.position.y + this.customConfig.viewer.lightSetting.dropShadowYOffset * size2.y;
		this.backScene.add(plane);

		let dirShadows = false;
		this.lightContainer = new THREE.Object3D();

		if (false && this.tmGui) {
			let gui = new dat.GUI({ autoPlace: true });
			gui.domElement.id = 'gui';
			gui.add(this.state, 'transmissionMultiplicator', 0.0, 3.0, 1.0).step(0.1).onChange(
				() => {
					this.gltfObject.children[0].traverse(
						(child) => {
							if (child.material) {
								if (child.material.type.toString() === 'MeshPhysicalMaterial') {
									child.material.transmission = this.state.transmissionMultiplicator;
									child.material.needsUpdate = true;
									this.renderUpdate = true;
								}
							}
						});
				});
			this.container.appendChild(gui.domElement)
		}

		if (this.customConfig.viewer.lightSetting.enableLeftLight) {

			var studioLightLeft = new THREE.DirectionalLight(this.customConfig.viewer.lightSetting.leftLightColor, this.customConfig.viewer.lightSetting.leftLightIntensity);

			studioLightLeft.name = 'Studio-LightLeft';
			studioLightLeft.position.set(this.customConfig.viewer.lightSetting.leftLightPositionX, this.customConfig.viewer.lightSetting.leftLightPositionY, this.customConfig.viewer.lightSetting.leftLightPositionZ);
			studioLightLeft.castShadow = this.customConfig.viewer.lightSetting.enableLeftLightShadow;
			studioLightLeft.shadow.camera.near = 0.1;
			studioLightLeft.shadow.camera.far = 500;
			studioLightLeft.shadow.camera.right = 17;
			studioLightLeft.shadow.camera.left = - 17;
			studioLightLeft.shadow.camera.top = 17;
			studioLightLeft.shadow.camera.bottom = - 17;

			if (!window.isMobile) {

				studioLightLeft.shadow.mapSize.width = 1024;
				studioLightLeft.shadow.mapSize.height = 1024;

			} else {

				studioLightLeft.shadow.mapSize.width = 1024;
				studioLightLeft.shadow.mapSize.height = 1024;

				/*if( isIphone6 ) {
	 
					studioLightLeft.shadow.mapSize.width = 1024;
					studioLightLeft.shadow.mapSize.height = 1024;
	 
				}*/
			}

			studioLightLeft.shadow.radius = 2;
			studioLightLeft.shadow.bias = -0.0005;
			this.lightContainer.add(studioLightLeft);

			if (this.customConfig.viewer.lightSetting.enableLeftLightShadow) dirShadows = true;

		}


		if (this.customConfig.viewer.lightSetting.enableRightLight) {

			var studioLightRight = new THREE.DirectionalLight(this.customConfig.viewer.lightSetting.rightLightColor, this.customConfig.viewer.lightSetting.rightLightIntensity);

			studioLightRight.name = 'Studio-LightRight';
			studioLightRight.position.set(this.customConfig.viewer.lightSetting.rightLightPositionX, this.customConfig.viewer.lightSetting.rightLightPositionY, this.customConfig.viewer.lightSetting.rightLightPositionZ);
			studioLightRight.castShadow = this.customConfig.viewer.lightSetting.enableRightLightShadow;
			studioLightRight.shadow.camera.near = 0.1;
			studioLightRight.shadow.camera.far = 500;
			studioLightRight.shadow.camera.right = 17;
			studioLightRight.shadow.camera.left = - 17;
			studioLightRight.shadow.camera.top = 17;
			studioLightRight.shadow.camera.bottom = - 17;

			if (!window.isMobile) {

				studioLightRight.shadow.mapSize.width = 1024;
				studioLightRight.shadow.mapSize.height = 1024;

			} else {

				studioLightRight.shadow.mapSize.width = 1024;
				studioLightRight.shadow.mapSize.height = 1024;

				/*if( isIphone6 ) {
	 
					studioLightRight.shadow.mapSize.width = 1024;
					studioLightRight.shadow.mapSize.height = 1024;
	 
				}*/
			}

			studioLightRight.shadow.radius = 2;
			studioLightRight.shadow.bias = -0.0005;
			this.lightContainer.add(studioLightRight);

			if (this.customConfig.viewer.lightSetting.enableRightLightShadow) dirShadows = true;

		}


		if (this.customConfig.viewer.lightSetting.enableBackLight) {

			var studioLightBack = new THREE.DirectionalLight(this.customConfig.viewer.lightSetting.backLightColor, this.customConfig.viewer.lightSetting.backLightIntensity);
			studioLightBack.name = 'Studio-LightBack';
			studioLightBack.position.set(this.customConfig.viewer.lightSetting.backLightPositionX, this.customConfig.viewer.lightSetting.backLightPositionY, this.customConfig.viewer.lightSetting.backLightPositionZ);
			studioLightBack.castShadow = this.customConfig.viewer.lightSetting.enableBackLightShadow;
			studioLightBack.shadow.camera.near = 0.1;
			studioLightBack.shadow.camera.far = 500;
			studioLightBack.shadow.camera.right = 17;
			studioLightBack.shadow.camera.left = - 17;
			studioLightBack.shadow.camera.top = 17;
			studioLightBack.shadow.camera.bottom = - 17;
			if (!window.isMobile) {

				studioLightBack.shadow.mapSize.width = 2048;
				studioLightBack.shadow.mapSize.height = 2048;

			} else {

				studioLightBack.shadow.mapSize.width = 1024;
				studioLightBack.shadow.mapSize.height = 1024;

				/*if( isIphone6 ) {
	 
					studioLightBack.shadow.mapSize.width = 1024;
					studioLightBack.shadow.mapSize.height = 1024;
	 
				}*/
			}
			studioLightBack.shadow.radius = 2;
			studioLightBack.shadow.bias = -0.0005;

			this.lightContainer.add(studioLightBack);

			if (this.customConfig.viewer.lightSetting.enableBackLightShadow) dirShadows = true;

		}

		this.scene.add(this.lightContainer);


		////////////////////////////////////////////////////////////////////
		// check:                                 //////////////////////////
		// should groundshadow be active or not   //////////////////////////
		////////////////////////////////////////////////////////////////////

		if (!dirShadows) {

			this.backScene.remove(plane);

		} else {

			////////////////////////////////////////////////////////////////////
			// add:                     ////////////////////////////////////////
			// main shadow on ground    ////////////////////////////////////////
			////////////////////////////////////////////////////////////////////

			//var studioLightTop = new THREE.DirectionalLight( 0xFFFFFF, 15 );
			const spotLight = new THREE.SpotLight(0xffffff);

			spotLight.position.set(0, 100 * size2.y, 0);

			spotLight.castShadow = true;

			spotLight.shadow.mapSize.width = 1024;
			spotLight.shadow.mapSize.height = 1024;

			/*  studioLightTop.name = 'Studio-LightTop';
			  studioLightTop.position.set( 0, 100, 0 );
			  studioLightTop.castShadow = true;
			  studioLightTop.shadow.camera.near    = 0.1;
			  studioLightTop.shadow.camera.far     = 500;
			  studioLightTop.shadow.camera.right   = 17;
			  studioLightTop.shadow.camera.left    = - 17;
			  studioLightTop.shadow.camera.top     = 17;
			  studioLightTop.shadow.camera.bottom  = - 17;
			  studioLightTop.shadow.mapSize.width  = 512;
			  studioLightTop.shadow.mapSize.height = 512;
			  studioLightTop.shadow.radius = 8;
			  studioLightTop.shadow.bias = -0.00005;*/
			this.backScene.add(spotLight);


		}

		////////////////////////////////////////////////////////////////////
		// add:         ////////////////////////////////////////////////////
		// LightProbe   ////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		if (this.customConfig.viewer.lightSetting.enableIBL) {

			this.lightProbe = new THREE.LightProbe();
			this.lightProbe.copy(new LightProbeGenerator.fromCubeTexture(this.textureList["lightProbe"]));
			this.lightProbe.intensity = this.customConfig.viewer.lightSetting.envMapIntensity;

			this.lightProbe.position.set(0, 0, 0);

			this.scene.add(this.lightProbe);

		}



		////////////////////////////////////////////////////////////////////
		// setup:       ////////////////////////////////////////////////////
		// billboards   ////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		if (this.customConfig.objects[this.actualModel].enableBillboards) {

			if (this.customConfig.objects[this.actualModel].billboards) {

				if (this.customConfig.objects[this.actualModel].billboards.length > 0) {

					for (let i = 0; i < this.customConfig.objects[this.actualModel].billboards.length; i++) {

						let spriteMaterial = new THREE.SpriteMaterial({ map: new THREE.TextureLoader().load(this.customConfig.objects[this.actualModel].billboards[i].desktop[0]), transparent: true, opacity: 0.0 });
						let sprite = new THREE.Sprite(spriteMaterial);


						sprite.name = this.customConfig.objects[this.actualModel].billboards[i].name;

						sprite.scale.x = this.customConfig.objects[this.actualModel].billboards[i].scale;
						sprite.scale.y = this.customConfig.objects[this.actualModel].billboards[i].scale;

						sprite.position.x = this.customConfig.objects[this.actualModel].billboards[i].positionX;
						sprite.position.y = this.customConfig.objects[this.actualModel].billboards[i].positionY;
						sprite.position.z = this.customConfig.objects[this.actualModel].billboards[i].positionZ;


						this.scene.add(sprite);
						this.billboards.push(sprite);

					}

				}

			}

		}

		////////////////////////////////////////////////////////////////////
		// add:                                              ///////////////
		// renderer´s domElement (canvas) to container (div) ///////////////
		////////////////////////////////////////////////////////////////////

		this.container.appendChild(this.renderer.domElement);
		if (this.showFps) this.container.appendChild(this.stats.dom);



		////////////////////////////////////////////////////////////////////
		// resize & run:         ///////////////////////////////////////////
		// render-loop           ///////////////////////////////////////////
		////////////////////////////////////////////////////////////////////

		this.resize();
		this.renderFrame();

		this.isRunning++;

		//console.clear();
		this.renderUpdate = true;
		this.resize();

	}

	setupPinPoints(gltfScene, objNr, customConfig) {

		var self = this;
		let pinPointKeyId = null;

		let endPoints = {};
		let hasEndPoints = false;
		let pinEndNoChild = false;

		gltfScene.traverse(function (object) {

			if (object.name.toString().indexOf("_end", 0) !== -1) {

				hasEndPoints = true;
				endPoints[object.name] = { x: object.position.x, y: object.position.y, z: object.position.z };

				if (object.parent.name.toString().toLowerCase().indexOf("_pp", 0) === -1) {

					pinEndNoChild = true;

				}

			}

		});

		for (let i = 0; i < customConfig.objects[objNr].pinPoints.length; i++) {

			hasEndPoints = true;
			endPoints[customConfig.objects[objNr].pinPoints[i].name + "_end"] = { x: customConfig.objects[objNr].pinPoints[i].positionX, y: customConfig.objects[objNr].pinPoints[i].positionY, z: customConfig.objects[objNr].pinPoints[i].positionZ, scale: customConfig.objects[objNr].pinPoints[i].scale }

		}

		gltfScene.traverse(function (object) {

			if (object.name.toString().indexOf("billboard", 0) !== -1) {

				object.visible = false;

			}

			let getNameKey = object.name.substring(0, object.name.length - 1);
			let getNameKeyAdvanced = self.pinPointNameKey.substring(0, self.pinPointNameKey.length - 2).toLowerCase() + "1";

			if (getNameKey.toLowerCase() === self.pinPointNameKey.substring(0, self.pinPointNameKey.length - 1).toLowerCase() || getNameKey.toLowerCase() === getNameKeyAdvanced) {

				pinPointKeyId = object.name.toLowerCase() + "_objLevel_" + objNr;

				if (self.textureList[pinPointKeyId]) {

					var spriteMaterial = new THREE.SpriteMaterial({ map: self.textureList[pinPointKeyId], transparent: true, opacity: 1.0 });
					var sprite = new THREE.Sprite(spriteMaterial);

					sprite.name = "pinpoint-base";

					if (window.isMobile) {

						spriteMaterial.map.anisotropy = 4;

					} else {

						spriteMaterial.map.anisotropy = 16;

					}


					spriteMaterial.map.encoding = THREE.sRGBEncoding;

					if (endPoints[object.name + "_end"]) {

						sprite.position.x = endPoints[object.name + "_end"].x;
						sprite.position.y = endPoints[object.name + "_end"].y;
						sprite.position.z = endPoints[object.name + "_end"].z;

					} else {

						sprite.position.y = object.position.y + 6;

					}


					if (hasEndPoints) {

						sprite.scale.x = customConfig.viewer.cameraSetting.positionZ * 0.45;
						sprite.scale.y = customConfig.viewer.cameraSetting.positionZ * 0.45;

						if (endPoints[object.name + "_end"].scale) {

							if (endPoints[object.name + "_end"].scale > 0) {

								sprite.scale.x = endPoints[object.name + "_end"].scale;
								sprite.scale.y = endPoints[object.name + "_end"].scale;

							}
						}

					} else {

						sprite.scale.x = 8.6;
						sprite.scale.y = 8.6;

					}


					object.add(sprite);

					if (false) {
						var material = new THREE.LineBasicMaterial({ color: 0x000000, transparent: true, opacity: 1.0 });
						var geometry = new THREE.BufferGeometry();
						console.log(geometry);
						if (endPoints[object.name + "_end"]) {

							geometry.vertices.push(new THREE.Vector3(endPoints[object.name + "_end"].x, endPoints[object.name + "_end"].y, endPoints[object.name + "_end"].z));

						} else {

							geometry.vertices.push(new THREE.Vector3(sprite.position.x, sprite.position.y, sprite.position.z));

						}

						geometry.vertices.push(new THREE.Vector3(0.0, 0.0, 0.0));

						var line = new THREE.Line(geometry, material);


						if (!self.showPins) {

							material.opacity = 0.0;
							spriteMaterial.opacity = 0.0;

						}

						object.add(line);
					}
					else {
						console.error("geometry.vertices == undefined");
					}

				}

			}

		});

		this.renderUpdate = true;

	}

	/* ---------------------------------------------------------------------------------------------------------------------- */
	/* -- enable: shadow.map(s) on model ------------------------------------------------------------------------------------ */
	/* ---------------------------------------------------------------------------------------------------------------------- */

	propagateShadow(obj, intensity, isShadow) {

		// return;
		obj.castShadow = obj.children.length < 1;
		obj.receiveShadow = obj.children.length < 1;



		const queryString = window.location.search;
		// let demoId = null;
		// const urlParams = new URLSearchParams(queryString);
		if (obj.hasOwnProperty('material')) {
			/*
			if (obj.material.type === "MeshPhysicalMaterial") {

				obj.material.map.anisotropy = 16;
				obj.material.map.encoding = THREE.sRGBEncoding;

				let _self = this;
				let albedoMap = obj.material.map;
				let roughMap = obj.material.roughnessMap;
				let metalMap = obj.material.metalnessMap;
				let normlMap = obj.material.normalMap;
				let envMap = this.extraEnvMap;
				envMap.mapping = THREE.CubeReflectionMapping;
				envMap.encoding = THREE.sRGBEncoding;


				albedoMap.anisotropy = 16;
				roughMap.anisotropy = 16;
				metalMap.anisotropy = 16;
				normlMap.anisotropy = 16;
				envMap.anisotropy = 16;


				if (!_self.customTransmission) {
					let loadTexture = new THREE.TextureLoader();
					loadTexture.load(this.customConfig.objects[0].customMap, function (texture) {

						texture.flipY = -1;
						_self.customTransmitMap = texture;
						obj.material = new THREE.MeshPhysicalMaterial({
							map: albedoMap,
							clearcoat: 0.2,
							clearcoatRoughness: 1.0,
							roughnessMap: roughMap,
							metalnessMap: metalMap,
							normalMap: normlMap,
							transmissionMap: texture,
							envMap: envMap,
							envMapIntensity: _self.customConfig.viewer.lightSetting.envMapExposure,
							ior: 2.333,
							reflectivity: 0.4,
							transmission: 0.8,
							opacity: 1,
							transparent: true,
						});

					});
					_self.customTransmission = true;



				} else {

					obj.material = new THREE.MeshPhysicalMaterial({
						map: albedoMap,
						clearcoat: 0.2,
						clearcoatRoughness: 1.0,
						roughnessMap: roughMap,
						metalnessMap: metalMap,
						normalMap: normlMap,
						transmissionMap: _self.customTransmitMap,
						envMap: envMap,
						envMapIntensity: _self.customConfig.viewer.lightSetting.envMapExposure,
						ior: 2.333,
						reflectivity: 0.4,
						transmission: 0.8,
						opacity: 1,
						transparent: true,
					});

				}

			}

			if (obj.material.map) {

				obj.material.map.anisotropy = 16;
				obj.material.map.encoding = THREE.sRGBEncoding;

			}

			if (obj.material.emissiveMap) {

				obj.material.emissiveMap.anisotropy = 16;
				obj.material.emissiveMap.encoding = THREE.sRGBEncoding;

				this.emissiveMap = obj.material;
				console.log("emissive:")
				console.log("emissive:" + this.emissiveMap)

			}


			if (obj.material.roughnessMap) {

				obj.material.roughnessMap.anisotropy = 16;

			}


			if (obj.material.metalnessMap) {

				obj.material.metalnessMap.anisotropy = 16;

			}

			if (obj.material.normalMap) {

				obj.material.normalMap.anisotropy = 16;
				obj.material.normalScale.y = -1;

			}

			if (this.customConfig.viewer.lightSetting.enableEnvironmentMap) {

				//obj.material.envMap = this.textureList["lightProbe"];
				//obj.material.envMap.encoding = THREE.sRGBEncoding;
				//obj.material.envMapIntensity = this.customConfig.viewer.lightSetting.envMapExposure;

			}
			*/
			if (this.extraEnvMap) {

				obj.material.envMap = this.extraEnvMap;
				obj.material.envMap.mapping = THREE.CubeReflectionMapping;
				obj.material.envMap.encoding = THREE.sRGBEncoding;
				obj.material.envMapIntensity = this.customConfig.viewer.lightSetting.envMapExposure;

			}

			obj.material.needsUpdate = true;

		}


		obj.children.forEach((o) => this.propagateShadow(o, intensity, isShadow));

	}

	/* ---------------------------------------------------------------------------------------------------------------------- */
	/* -- reset: auto rotation ---------------------------------------------------------------------------------------------- */
	/* ---------------------------------------------------------------------------------------------------------------------- */

	resetAutoRotation(self) {
		self.autoRotationCount = 0;
	}

	getToken = async () => {
		const { token, code, message } = await post('/api/login', {
			username: 'admin',
			password: 'q1w2e3r4'
		})
		if (token) {
			this.setState({
				jwtToken: token
			})
		}
		if (code) {
			throw {
				code: code,
				message: message
			}
		}
	}

	subDomain(url) {

		url = url.replace(new RegExp(/^\s+/), ""); // START
		url = url.replace(new RegExp(/\s+$/), ""); // END

		url = url.replace(new RegExp(/\\/g), "/");

		url = url.replace(new RegExp(/^http\:\/\/|^https\:\/\/|^ftp\:\/\//i), "");

		url = url.replace(new RegExp(/^www\./i), "");

		url = url.replace(new RegExp(/\/(.*)/), "");

		if (url.match(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i))) {
			url = url.replace(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i), "");

		} else if (url.match(new RegExp(/\.[a-z]{2,4}$/i))) {
			url = url.replace(new RegExp(/\.[a-z]{2,4}$/i), "");
		}

		var subDomain = (url.match(new RegExp(/\./g))) ? true : false;

		return (subDomain);

	}

	/* ---------------------------------------------------------------------------------------------------------------------- */
	/* -- resize: player ---------------------------------------------------------------------------------------------------- */
	/* ---------------------------------------------------------------------------------------------------------------------- */

	resize() {

		this.container = this.divRef.current;

		this.width = this.container.offsetWidth;
		this.height = this.container.offsetHeight;

		this.renderer.setSize(this.width, this.height);

		this.camera.aspect = this.width / this.height;
		this.camera.updateProjectionMatrix();


		if (this.customConfig.viewer.enableFitToScreen) {
			const box = new THREE.Box3().setFromObject(this.gltfObject.children[0]);
			const size = box.getSize(new THREE.Vector3()).length();
			const size2 = box.getSize(new THREE.Vector3());
			const center = box.getCenter(new THREE.Vector3());
			this.controls.reset();

			this.gltfObject.position.set(0, 0, 0);
			this.gltfObject.rotation.set(0, 0, 0);
			this.gltfObject.rotation.y = .78;

			this.camera.position.set(0, 0, 0);

			if (size < this.controls.minDistance) {

				this.controls.minDistance = size;

				if (size < 1) {

					this.controls.minDistance = size * this.customConfig.objects[0].transformers[0].scale * 0.5;

				}

			}

			if (size > this.controls.maxDistance) this.controls.maxDistance = size;

			this.camera.near = size / 100;
			this.camera.far = size * 100;
			this.camera.updateProjectionMatrix();

			this.camera.position.copy(center);
			this.camera.position.x += size / 2.0;
			this.camera.position.y += size / 5.0;
			this.camera.position.z += size / 2.0;


			if (this.customConfig.objects[0].transformers[0]) {

				this.gltfObject.scale.set(this.customConfig.objects[0].transformers[0].scale, this.customConfig.objects[0].transformers[0].scale, this.customConfig.objects[0].transformers[0].scale);

				this.gltfObject.position.x += this.customConfig.objects[0].transformers[0].positionX;
				this.gltfObject.position.y += this.customConfig.objects[0].transformers[0].positionY;
				this.gltfObject.position.z += this.customConfig.objects[0].transformers[0].positionZ;

				this.gltfObject.rotation.x += this.customConfig.objects[0].transformers[0].rotationX;
				this.gltfObject.rotation.y += this.customConfig.objects[0].transformers[0].rotationY;
				this.gltfObject.rotation.z += this.customConfig.objects[0].transformers[0].rotationZ;

			}


			this.camera.position.x += this.customConfig.viewer.cameraSetting.positionX;
			this.camera.position.y += this.customConfig.viewer.cameraSetting.positionY;
			this.camera.position.z += this.customConfig.viewer.cameraSetting.positionZ;

			this.camera.lookAt(center);

			this.controls.update();

		}

		if (this.modelShadowCaster) {

			this.modelShadowCaster.visible = true;
			this.modelShadowCaster.scale.set(this.gltfObject.scale.x, this.gltfObject.scale.y, this.gltfObject.scale.z);

		}



		this.renderUpdate = true;

	}

	/* ---------------------------------------------------------------------------------------------------------------------- */
	/* -- render: player ---------------------------------------------------------------------------------------------------- */
	/* ---------------------------------------------------------------------------------------------------------------------- */


	renderFrame() {

		this.stats.begin();


		if (this.autoRotationCount >= this.startRotationAt && this.controls.initialObj.autoRotate) {

			this.controls.initialObj.playAutoRotation = true;

		}

		let delta = this.clock.getDelta();

		if (this.currentMixer) {

			this.currentMixer.update(delta);
			this.currentShadowMixer.update(delta);
			this.renderUpdate = true;

		}


		if (this.controls.initialObj.autoRotate) this.autoRotationCount++;

		if (this.renderUpdate) {

			this.lightContainer.quaternion.copy(this.camera.quaternion);

			this.renderer.autoClear = true;
			this.renderer.render(this.backScene, this.camera);
			this.renderer.autoClear = false;
			this.renderer.render(this.scene, this.camera);

			this.renderUpdate = false;

		}

		this.controls.update();

		if (this.getPastAzimuth !== this.controls.getAzimuthalAngle() || this.getPastPolar !== this.controls.getPolarAngle()) {

			this.renderUpdate = true;

		}

		this.getPastAzimuth = this.controls.getAzimuthalAngle()

		if (this.controls.initialObj.onStart) {

			this.controls.initialObj.onStart = false;

		}

		if (this.width !== this.container.offsetWidth || this.height !== this.container.offsetHeight) {

			this.resize();

		}

		this.stats.end();

		this.frameRequest = requestAnimationFrame(() => {

			this.renderFrame();

		});

	}

	componentWillUnmount() {
		cancelAnimationFrame(this.frameRequest);
	}

	render() {
		return < div
			id="mainContainer"
			ref={this.divRef}
			style={{
				display: "block",
				width: "100vw",
				height: "100vh",
				overflow: "hidden",
				margin: 0,
			}}
		/>;
	}
}

export default TinkerGrounds;
